<template>
  <div class="bigdata-home">
    <navBarNoLab :onIndex="2" />
    <!-- 背景部分 -->
    <backGroundCom :backGroundCom = "backGroundComInfo">
      <template #navList>
        <pageElement :onIndex="4" />
      </template>
    </backGroundCom>
    <!-- 真项目源自于真企业 -->
    <realProjectCom :realProjectCom = "realProjectComInfo" />
    <!-- 好项目需要真材实料 -->
    <sourceCom :sourceComInfo = "sourceComInfo" />
    <!-- 大数据底部基础信息 -->
    <bottomWidge />
  </div>
</template>

<script>
import navBarNoLab from "@/views/components/navBarNoLab"
import backGroundCom from "./components/backGroundCom"
import realProjectCom from "./components/realProjectCom"
import sourceCom from "./components/sourceCom"
import bottomWidge from "@/views/components/bottomWidge"
// 导航抽离
import pageElement from "../common/pageElement"

export default {
  components: {
    navBarNoLab,
    backGroundCom,
    realProjectCom,
    sourceCom,
    bottomWidge,
    pageElement
  },
  name: 'homeBigData',
  data () {
    return {
      backGroundComInfo: {
        onIndex: 4,
        backGroundImg: "../bigDataImg/img_bj@1.5x.jpg",
        title: "大数据风口的摆渡人",
        enTitle: "Ferries to the big data tuyere",
        projectList: [
          {"typeList": "大厂级", "realList": "深度项目"},
          {"typeList": "多行业", "realList": "大型项目"},
          {"typeList": "基于企业", "realList": "真实项目"},
          {"typeList": "企业真实", "realList": "研发环境"}
        ]
      },
      realProjectComInfo: {
        title: "真项目 源自于真企业",
        mainNum: "8",
        main: "大主流行业",
        coreNum: "12",
        core: "个精髓项目打造不世之作"
      },
      sourceComInfo: {
        title: "好项目 需要真材实料",
        contrastNum: "7",
        projectTitle: "对比项目",
        project: [ "天数", "架构完整性", "真实业务数据", "调优", "架构验证", "实时计算", "Flink" ],
        trainTitle: "其他培训机构",
        trainWord: "数据来自市场其他5个培训机构",
        otherTrain: [ "小于30天", "单点技术讲解实现", "来自于真实项目场景业务数据", "自行杜撰数据", "无", "无", "无" ]
      }
    }
  }
}
</script>

<style lang="scss">
  .bigdata-home {
    min-width: 1200px;
    background-color: white;
  }
</style>